import React from "react";
import LayoutComponent from "components/LayoutComponent";
import About from "./About";

function action() {
  return {
    chunks: ["about"],
    title: "About: online-jigsaw-puzzles",
    description:
      "Play Jigsaw Puzzle online for free. These games are free to play and you can download them as well.",
    pathname: "/about",
    component: (
      <LayoutComponent>
        <About />
      </LayoutComponent>
    )
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/about/index.js